module.exports = __webpack_public_path__ + "static/cover-large-3-8ca325cd5230d91178d6c904f16c321a.jpg";